module.exports = __webpack_public_path__ + "img/panel-economic.ca35059e.svg";